import React from 'react';
// import { NavLink } from 'react-router-dom';
import routes from '../routes';

function Sidebar() {
	return (
		<nav className="pcoded-navbar">
			<div className="nav-list">
				<div className="pcoded-inner-navbar main-menu">
					<ul className="pcoded-item pcoded-left-item">
						{routes.map((e, k) => {
							return (
								<li
									key={k}
									className={`${
										e.children ? 'pcoded-hasmenu' : ''
									} ${
										window.location.pathname.startsWith(
											e.start
										)
											? 'active pcoded-trigger'
											: ''
									}`}
								>
									<a
										href={e.link}
										className="waves-effect waves-dark"
									>
										<span className="pcoded-micon">
											<i
												className={
													e.icon
														? e.icon
														: 'feather icon-home'
												}
											></i>
										</span>
										<span className="pcoded-mtext">
											{e.title}
										</span>
									</a>
									{e.children && (
										<ul className="pcoded-submenu">
											{e.children.map((child, k) => (
												<li
													key={k}
													className={`${
														window.location.pathname.startsWith(
															child.start
														)
															? 'active'
															: ''
													}`}
												>
													<a
														className="waves-effect waves-dark"
														href={child.link}
													>
														<span className="pcoded-mtext">
															{child.title}
														</span>
													</a>
												</li>
											))}
										</ul>
									)}
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</nav>
	);
}

export default Sidebar;
